import RestClientService from 'Services/RestClientService';

class SettingsApiService {
  static async getAll() {
    return RestClientService.Get('settings');
  }

  static async getMaintenance() {
    return RestClientService.Get('settings/maintenance');
  }

  static async updateKeyword(data) {
    return RestClientService.Post('settings', data);
  }

  static async updateTemplate(id, data) {
    return RestClientService.Patch(`settings/${id}`, data);
  }

  static async createTemplate(data) {
    return RestClientService.Post('settings', data);
  }

  static async createTemplateOption(parentId, data) {
    return RestClientService.Post(`settings/template-option/${parentId}`, data);
  }

  static async updateTemplateOption(parentId, templateIndex, data) {
    return RestClientService.Post(`settings/template-option/${templateIndex}/update`, {
      ...data,
      parentId,
    });
  }

  static async deleteTemplateOption(parentId, templateIndex) {
    return RestClientService.Delete(`settings/template-option/${parentId}/${templateIndex}`);
  }

  static async deleteKeyword(keywordId) {
    return RestClientService.Delete(`settings/keyword/${keywordId}`);
  }
}

export default SettingsApiService;
